document.addEventListener('DOMContentLoaded', function() {
  
  document.addEventListener('click', function(e) {
    let target = checkEventTarget(e, '._js-search-more');
    if (!target) {
      return;
    }
    let searchBlock = target.closest('._js-search-result');
    let searchBtn = document.querySelector('._js-search-btn');
    let nextPage = target.dataset.next;
    if (searchBlock) {
      let paramName = searchBlock.dataset.paginationName;
      let params = [];
      params = getParametersExcluding(window.location.href, paramName);

      searchBlock?.classList.add('_disabled');
      searchBtn?.classList.add('_disabled');

      getSearchResult(params, nextPage)
          .then(res => {
            if (res.data?.html) {
              updateSearchDOM(res.data.html, searchBlock);
              updateURLParams(paramName, nextPage);
            }
          })
          .catch(error => console.error('Ошибка загрузки контента:', error))
          .finally(() => {
            searchBlock?.classList.remove('_disabled');
            searchBtn?.classList.remove('_disabled');
          });
    }
  });

  document.addEventListener('submit', function (e) {
    let target = checkEventTarget(e, '._js-search-page-form');
    if (!target) {
      return;
    }
    e.preventDefault();

    let searchBlock = document.querySelector('._js-search-result');
    let searchBtn = target.querySelector('._js-search-btn');
    if (searchBlock) {
      let paginationName = searchBlock.dataset.paginationName;
      if (paginationName) {
        updateURLParams(paginationName, "");
      }
      let data = new FormData(target);
      let dataArray = {};

      data.forEach(function(value, key) {
        dataArray[key] = value;
      });

      searchBlock?.classList.add('_disabled');
      searchBtn?.classList.add('_disabled');

      getSearchResult(dataArray)
          .then(res => {
            if (res.data?.html) {
              updateSearchDOM(res.data.html, searchBlock, true);
              for (let pair of data.entries()) {
                updateURLParams(pair[0], pair[1] ?? "");
              }
            }
          })
          .catch(error => console.error('Ошибка загрузки контента:', error))
          .finally(() => {
            searchBlock?.classList.remove('_disabled');
            searchBtn?.classList.remove('_disabled');
          });
    }

  });
  function updateSearchDOM(resHTML, blockDOM, wholeBlock = false) {
    let answerDOM = getDocumentObjectFromHtmlString(resHTML, false);
    if (answerDOM) {
      if (wholeBlock) {
        blockDOM.innerHTML = answerDOM.innerHTML;
        scrollToNode(blockDOM);
      } else {
        let elementsListInDOM = blockDOM.querySelector('._js-search-list');
        let elementsListInAnswer = answerDOM.querySelector('._js-search-list');
        let paginationInDOM = blockDOM.querySelector('._js-search-more');
        let paginationInAnswer = answerDOM.querySelector('._js-search-more');

        if (elementsListInAnswer) {
          elementsListInDOM.innerHTML += elementsListInAnswer.innerHTML;
        }
        if (paginationInDOM && paginationInAnswer) {
          paginationInDOM.parentNode.replaceChild(paginationInAnswer, paginationInDOM);
        } else {
          paginationInDOM.parentNode.removeChild(paginationInDOM);
        }
      }
    }
  }
});
